import { ErrorHandler } from '@angular/core';
import { LoggingService } from '../services/logging.service';
import { ErrorHandlerService } from '../services/error-handler.service';

export const provideApplicationInsights = () => {
  return [
    LoggingService,
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerService,
    },
  ];
};
